import type { FaireProductEntity } from "../../entity_types/product";

export const p_njxz3bfg02: FaireProductEntity = {
  token: "p_njxz3bfg02",
  type: "product",
  name: "Forest Fern Wrap",
  brandToken: "b_1wo9c78f",
  brandName: "Liamolly",
  imageUrl:
    "https://cdn.faire.com/fastly/f442adb0255671ff7a7c9ad966d78a87d0c83ddde9e728f1a761e1f4a3ffc192.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/77388de3d9d6e90b87486c71b6f668b37ff3932a99e42cb18e80e21c7dc18f86.jpeg",
    "https://cdn.faire.com/fastly/7b84384f04e93c52dae1d3e461e9cf8c95128951c9d89654dda70136080041c7.jpeg",
    "https://cdn.faire.com/fastly/3dafa53fccb8fd7b0334fe74e125ed2d7797cdc51f04bfa99a2c33aac2e7db0c.jpeg",
    "https://cdn.faire.com/fastly/a2a7409f2b3cc5e24072b8f77794aada40af30103f9c32b7f5a1d22cd30eea0f.jpeg",
    "https://cdn.faire.com/fastly/0f38a2cab7fc5a7a7a92c9ec6f2d04007c8da60de233445c9c241070f19a9ebe.jpeg",
    "https://cdn.faire.com/fastly/688e4c262234f90bdc9590a5aabf83b518bf3db4886f416516bbe98cec77d5c7.jpeg",
    "https://cdn.faire.com/fastly/284e966d99204701203ad74779d61eb54e3e6fc7133c31c0d9aa1085a3d2e0fe.jpeg",
    "https://cdn.faire.com/fastly/65cd3e8dc615ce40296be8eca1ecd7e8ec10beda63018605ce6b9a5c5d5bc33e.jpeg",
    "https://cdn.faire.com/fastly/45f41774cfa298d03bb156aec3cbcc8e85f17210d74a9047ec41416ff4e3aa35.jpeg",
    "https://cdn.faire.com/fastly/b6e5c9393b9ea54e536b9200245a507aa679b6ae5bbfb4bdc06b001ec8b60ea4.jpeg",
    "https://cdn.faire.com/fastly/0920f1a59186fb7e55d8f4fc689c962bd78a9f0f00a8a7d7cc0580bc1f0dc8ab.jpeg",
    "https://cdn.faire.com/fastly/f5cde5ac95d3627bdd298bed1f19d6f4fc282b1d3b86ed342e47cd90d8ded8fe.jpeg",
    "https://cdn.faire.com/fastly/b58d56387cd4720d61568aaf37085b6a39e88febd061462fa5276c2e64340835.jpeg",
    "https://cdn.faire.com/fastly/a9f56ad2e79e648d19d9dd4d68530e9cafc49553c60776c280ae2edd24283e21.jpeg",
    "https://cdn.faire.com/fastly/abab08c8095779988dbbe2d445266970bb12ec693cec1bd95f94ebe77d83a278.jpeg",
    "https://cdn.faire.com/fastly/e56bc9ec4fc6bc98769c3c73763b556f5e80823accb33b611cb09d4515ed2da8.jpeg",
  ],
  priceDollars: 69,
  description:
    "100% Italian spun long-staple Egyptian cotton. As soft as cashmere but pure cotton. Great for travel, chilly nights, campfires, and the beach. Wrap it, drape it, knot it into a generous scarf.\nReversible for a beautiful drape.\n24x74\nMachine wash, delicate, cold water, just a little soap and a bit of fabric softener then tumble dry on low heat delicate cycle, press with warm iron when just slightly damp.",
  tags: [],
  msrpDollars: 138,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:56.914Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
